import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import caGregorian from 'cldr-dates-full/main/it/ca-gregorian.json';
import numbers from 'cldr-numbers-full/main/it/numbers.json';
import grammaticalFeatured from 'cldr-core/supplemental/grammaticalFeatures.json';
import dateFields from 'cldr-dates-full/main/it/dateFields.json';
import timeZoneNames from "cldr-dates-full/main/it/timeZoneNames.json";
import itMessages from "./it.json";
import { load, loadMessages, } from "@progress/kendo-react-intl";

load( likelySubtags, currencyData, weekData, numbers, caGregorian, dateFields, timeZoneNames, grammaticalFeatured );
loadMessages(itMessages, "it");

